import { Outlet } from 'react-router';
import OrderPageStoreProvider from './store/OrderPageStoreProvider';
import type { FC } from 'react';

const OrderPage: FC = () => (
  <OrderPageStoreProvider>
    <Outlet />
  </OrderPageStoreProvider>
);

export default OrderPage;
